import { ProcessIdKeysInLocalStorage } from '../enums';
import type { ProcessIdWithTimestamp } from './types';

export const uploadProcessIdLocalStorageManager = {
  getProcessObject: () => {
    const localStorageProcessIdsWithTimestamps: ProcessIdWithTimestamp[] =
      JSON.parse(
        localStorage.getItem(
          ProcessIdKeysInLocalStorage.UploadProcessesQueue,
        ) || '[]',
      );

    return localStorageProcessIdsWithTimestamps;
  },

  setProcessObject: (
    localStorageProcessIdsWithTimestamps: ProcessIdWithTimestamp[],
  ) => {
    localStorage.setItem(
      ProcessIdKeysInLocalStorage.UploadProcessesQueue,
      JSON.stringify(localStorageProcessIdsWithTimestamps),
    );
  },

  removeProcessObject: (
    localStorageProcessIdsWithTimestamps: ProcessIdWithTimestamp[],
    processId: string,
  ) => {
    if (localStorageProcessIdsWithTimestamps.length > 0) {
      localStorageProcessIdsWithTimestamps =
        localStorageProcessIdsWithTimestamps.filter(
          (item) => item.processId !== processId,
        );
    }
    return localStorageProcessIdsWithTimestamps;
  },
};
